import React, { useEffect, useState } from "react";
import "./FindMatches.css";
import { useLocation, useParams } from "react-router-dom";
import SkillMatches from "../../../SkillMatches/SkillMatches";
import { useDispatch, useSelector } from "react-redux";
import { SearchValue, getJobDetail, matchesReset } from "../../../../redux/actions";
import SearchGigs from "../../../SearchSkillListing/SearchGigs";
import Loader from "../../../../components/Loading/Loader";

export default function FindMatches({ }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { id, name } = useParams();
  
  const jobdetails = useSelector((state) => state.getJobDetailReducer.jobdetails);
  const loading = useSelector((state) => state.getJobDetailReducer.loading);

  const [jobDetails, setJobdetails] = useState([])

  useEffect(() => {
    dispatch(matchesReset())
    dispatch(SearchValue(""))
    // if (location.search != '') {
    //   let searchParams = new URLSearchParams(window.location.search);
    //   var filters = {}
    //   searchParams.forEach((value, key) => {
    //     filters[key] = value
    //   });
    //   dispatch(fetchFindMyMatches({ id: parseInt(location.pathname.split('findmatches/')[1]), filters }))
    //   dispatch(fetchMatchesCount({ id: parseInt(location.pathname.split('findmatches/')[1])}))
    // }
    // else {
    //   dispatch(fetchFindMyMatches({ id: id }));
    //   dispatch(fetchMatchesCount({ id: location.pathname.split('findmatches/')[1]?.split('/')[0]}))
    // }

    if (location.state?.Id) {
      return setJobdetails(location.state.jobdetails)
    } else {
      dispatch(getJobDetail(id))
    }
  }, []);
  useEffect(()=>{setJobdetails(jobdetails[0])},[jobdetails])

  return (
    jobDetails?.length === 0 ? <Loader /> :
      <SearchGigs 
      findMatch={true} 
      job_title={location.state?.Title ? location.state?.Title : jobdetails.length > 0 && jobdetails[0].skills.SkillName} 
      job_id={id} 
      jobdetails={location?.state?.jobdetails ?? jobdetails} />
  );
}
